import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ClientReviews = () => {
  const [currentReview, setCurrentReview] = useState(0);

  const reviews = [
    {
      id: 1,
      quote: "We had a dream for our forever home—and Vesta Designs brought it to life beautifully. Every space feels intentional, cozy, and truly ours. The team was patient, attentive, and incredibly talented.",
      author: "Thao Le",
      role: "Homeowner"
    },
    {
      id: 2,
      quote: "Working with this team was an absolute pleasure. They understood our vision from day one and transformed our commercial space beyond what we imagined possible.",
      author: "John Doe",
      role: "Homeowner"
    },
    {
      id: 3,
      quote: "The attention to detail and creative solutions exceeded all our expectations. Our new office space is both functional and incredibly inspiring to work in every day.",
      author: "Sarah Chen",
      role: "Business Owner"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [reviews.length]);

  const goToReview = (index) => {
    setCurrentReview(index);
  };

  return (
    <section className="reviews-arch04">
      <div className="reviews-arch04-container">
        <motion.h2 
          className="reviews-arch04-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Client Reviews
        </motion.h2>

        <div className="reviews-arch04-slider">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentReview}
              className="reviews-arch04-item"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            >
              <svg className="quote-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
              <p className="reviews-arch04-quote">{reviews[currentReview].quote}</p>
              <div className="reviews-arch04-author">
                <span className="author-name">{reviews[currentReview].author},</span>
                <span className="author-role">{reviews[currentReview].role}</span>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="reviews-arch04-nav">
            <span className="reviews-counter">
              {String(currentReview + 1).padStart(2, '0')}
              <span className="divider">/</span>
              {String(reviews.length).padStart(2, '0')}
            </span>
            <div className="reviews-dots">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  className={`review-dot ${index === currentReview ? 'active' : ''}`}
                  onClick={() => goToReview(index)}
                  aria-label={`Review ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientReviews;
